import Vue from "vue";
import {
  emergencyMapActions,
  emergencyMapState
} from "@/store/modules/emergency";
import { quickpayMapState } from "@/store/modules/quickpay";
import { logoPath } from "@/helpers/generalHelpers";
import { getSystemFilesURL } from "@/helpers";
export default Vue.extend({
  data() {
    return {
      modalDetails: { name: "", description: "", title: "", icon: "" },
      activeTabName: "inquiry",
      tempEmergency: false,
      logoPath: "",
      quickPayBackgroundImage: "",
      loading: false,
      country: "",
      callBillingString: "Please Call Billing at 888-786-0003, option #2"
    };
  },
  async mounted() {
    try {
      const [logoPathImage, quickPayBackgroundImage] = await Promise.all([
        logoPath(),
        getSystemFilesURL("quickpay-bg")
      ]);
      if (logoPathImage) {
        this.logoPath = logoPathImage;
      }
      if (quickPayBackgroundImage) {
        this.quickPayBackgroundImage = quickPayBackgroundImage;
      }
    } catch (error) {
      this.$bugSnagClient.notify(error);
    }
  },
  methods: {
    ...emergencyMapActions(["checkEmergency"]),
    getLogoPath() {
      return logoPath();
    },
    handleClick() {
      //do nothing
    },
    showModal(details: {
      title: string;
      description: string;
      icon: string;
      modalName: string;
    }) {
      this.modalDetails.title = details.title;
      this.modalDetails.description = details.description;
      this.modalDetails.icon = details.icon;
      this.$modal.show(details.modalName);
    },
    doShutDown() {
      this.$router.push({
        path: `/emergency-maintenance`,
        query: {
          message:
            "Sorry, payment feature is undergoing emergency maintenance. Please try again later"
        }
      });
    },
    gotoPrevious() {
      this.activeTabName = "inquiry";
    },
    geoLocationError() {
      this.modalDetails.title = `Service Unavailable in Your Country (${this.country})`;
      this.modalDetails.description = `We’re sorry, but payments are only supported within the United States and Canada. ${this.callBillingString}`;
      this.$modal.show("quickPayModal");
    },
    async userIsInUS(): Promise<boolean> {
      try {
        if (
          process.env.VUE_APP_ENV !== "production" &&
          this.$route.query.mode !== "test"
        ) {
          return true;
        }

        this.loading = true;

        const apiKey = process.env.VUE_APP_GOOGLE_API_PLACES_KEY;
        if (!apiKey) {
          throw new Error("Missing API key");
        }

        const geoLocateRes = await fetch(
          `https://www.googleapis.com/geolocation/v1/geolocate?key=${apiKey}`,
          { method: "POST" }
        );
        const { location = {} } = await geoLocateRes.json();
        const { lat, lng } = location as { lat?: number; lng?: number };

        if (!lat || !lng) {
          this.geoLocationError();
          return false;
        }

        const geocodeRes = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`
        );
        const geoData = await geocodeRes.json();
        if (!geoData.results?.length) {
          this.geoLocationError();
          return false;
        }

        for (const result of geoData.results) {
          const countryComp = result.address_components.find((c: any) =>
            c.types.includes("country")
          );
          if (countryComp) {
            this.country = countryComp.long_name;
            break;
          }
        }

        if (!this.country) {
          this.geoLocationError();
          return false;
        }

        const allowed = ["United States", "Canada"];
        const isAllowed = allowed.includes(this.country);
        if (!isAllowed) {
          this.geoLocationError();
        }
        return isAllowed;
      } catch (err) {
        console.error("Geo lookup failed", err);
        this.geoLocationError();
        return false;
      } finally {
        this.loading = false;
      }
    },
    checkBrowserSupport(): boolean {
      const ua = navigator.userAgent;
      // true for Safari but not Chrome/Chromium/Android
      const isSafari = /^((?!chrome|android).)*safari/i.test(ua);

      if (isSafari) {
        this.modalDetails.title = "Browser Not Supported";
        this.modalDetails.description =
          "QuickPay currently has issues on Safari. Please switch to Chrome, Brave, or Firefox for the best experience.";
        this.modalDetails.icon = "warning";
        this.$modal.show("quickPayModal");
        return false;
      }
      return true;
    }
  },
  computed: {
    ...quickpayMapState(["makingApiRequest", "policyInfo"]),
    ...emergencyMapState(["emergencyData"]),
    initWithBillPayData(): boolean {
      return !!(
        this.$route.query.prefix &&
        this.$route.query.policyNumber &&
        this.$route.query.companyNumber
      );
    }
  },
  watch: {
    "emergencyData.isInEmergencyMaintenanceMode": {
      handler(isInEmergencyMaintenanceMode: boolean) {
        if (isInEmergencyMaintenanceMode) {
          this.doShutDown();
        }
      },
      immediate: false
    },
    "emergencyData.isInFiservScheduledMaintenanceMode": {
      handler(isInFiservScheduledMaintenanceMode: boolean) {
        if (isInFiservScheduledMaintenanceMode) {
          this.$router.push({
            path: `/emergency-maintenance`,
            query: {
              message: this.emergencyData?.fiservMaintenanceModeMessage
            }
          });
        }
      },
      immediate: false
    }
  }
});
